export default "__VITE_ASSET__A_e6CzLi__"